import store from '../store';
import {setGpsLocation} from "../store/coreSlice";

let watcher = null;

export function enableGps() {
	if( watcher )
		return; // Already

	console.log("Setting up GPS...");
	if (navigator.geolocation) {
		watcher = navigator.geolocation.watchPosition(onLocationUpdate);

		navigator.geolocation.getCurrentPosition(function (position) {
			var pos = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};

			if (pos.lat < 42.145716 || pos.lat > 42.3572467 ||
				pos.lng > -83.4807017 || pos.lng < -84.0040694)
				return; // out of the area

			window.map.setCenter(pos);
			// window.map.setZoom(16);
			// store.dispatch(zoomChanged(16));
		}, function () {
			// Location couldn't be found, nbd
		});

		// Fires whenever the GPS location changes
		function onLocationUpdate(position) {
			const state = store.getState();

			if( !state.core.gpsLocation || position.coords.latitude !== state.core.gpsLocation[0] || position.coords.longitude !== state.core.gpsLocation[1] )
				store.dispatch(setGpsLocation([position.coords.latitude, position.coords.longitude]));
		}
	}
}

export function disableGps() {
	if( !watcher )
		return;

	navigator.geolocation.clearWatch(watcher);
}